var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4609 15.723C22.2358 11.3273 20.6428 6.1349 16.5892 3.68754C13.66 1.91899 10.1861 2.0308 7.44555 3.66487L6.30701 1.58104C9.73268 -0.461498 14.075 -0.601263 17.7365 1.60943C22.8887 4.72013 24.8609 11.3787 22.4605 16.9303L24 17.8598L19.2214 20.5162L19.0321 14.8603L20.4609 15.723ZM3.53908 8.27699C1.76422 12.6727 3.35729 17.865 7.41078 20.3124C10.34 22.081 13.8138 21.9692 16.5542 20.3353L17.6928 22.419C14.2672 24.4615 9.92497 24.6012 6.26347 22.3906C1.11134 19.2799 -0.860886 12.6213 1.53945 7.06968L0 6.14021L4.77861 3.48373L4.96798 9.13971L3.53908 8.27699Z",
    fill: "#229986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62698 13.7077V12.2632H11.3576C12.4498 12.2632 13.2422 12.028 13.7348 11.5577C14.2274 11.0874 14.4737 10.4883 14.4737 9.76038C14.4737 8.88692 14.2059 8.19824 13.6705 7.69432C13.1351 7.1904 12.3213 6.94405 11.2291 6.95524H7.40625V5.9978H17.7022V6.95524H13.4939L13.9918 6.48492C14.7521 6.78727 15.2875 7.2352 15.598 7.8287C15.9193 8.411 16.0799 9.06609 16.0799 9.79397C16.0799 10.6114 15.8925 11.3169 15.5177 11.9104C15.1429 12.4927 14.6075 12.9406 13.9115 13.2542C13.2261 13.5565 12.3909 13.7077 11.4058 13.7077H8.62698ZM14.5379 17.7558L11.5985 13.0862H13.3332L16.2887 17.7558H14.5379ZM7.40625 9.29005V8.33261H17.7022V9.29005H7.40625Z",
    fill: "#229986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/Transactions_icon.9d0bd8a1cf49d35ee7053a549ee1961f.svg";
export { ForwardRef as ReactComponent };